import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_3760920352 from "../../../../../packages/component/src/components/animate/demo/demo1.js?loadDemo";
import legacyImportDemo_2057365507 from "../../../../../packages/component/src/components/animate/demo/demo2.js?loadDemo";
import legacyImportDemo_2258268258 from "../../../../../packages/component/src/components/animate/demo/demo3.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_3760920352,
  legacyImportDemo_2057365507,
  legacyImportDemo_2258268258,
  React
};